<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
    <p>
      This site is still under construction<br>
      Feel free to check back later.
    </p>
    <pre>lab#unnatural.dev</pre>
    <div class="meeting-container">
      <meting-js server="tencent" type="song" id="000akynZ2Rbro5" loop="none" mini="true"></meting-js>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.meeting-container {
  margin: auto;
  margin-top: 3em;
  max-width: 66px;
}
</style>
